import { dia, elementTools, g } from '@joint/core';

export class StepOffsetControl extends elementTools.Control{

    protected override getPosition(view: dia.ElementView) {
        const { model } = view;
        const { width, height } = model.size();
        const controlLevel = height * 0.5;
        const attrs = model.get('attrs') || {};
        let offset = 0;
        if (attrs['control']) {
            offset  = attrs['control']['offset'] || 0;
        }
        const offsetSide = new g.Line(new g.Point(offset, 0), new g.Point(offset, height));
        const levelLine = new g.Line(new g.Point(0, controlLevel), new g.Point(width, controlLevel));
        const controlPoint = offsetSide.intersect(levelLine);
        return controlPoint ?? { x: 0, y: controlLevel };
    }

    protected override setPosition(view: dia.ElementView, coordinates: dia.Point) {
        const { model } = view;
        const { width } = model.size();
        const offset = Math.max(0, Math.min(coordinates.x, width));
        const attrs = model.get('attrs') || {};
        if (attrs['control']) {
            attrs['control']['offset'] = offset;
            model.attr('body/d', `
                    M 0 0
                    L ${offset} calc(0.5 * h)
                    L 0 calc(h)
                    L calc(w - ${offset}) calc(h)
                    L calc(w) calc(0.5 * h)
                    L calc(w - ${offset}) 0
                    Z
                `
            );
        }
    }
}
